import { render, staticRenderFns } from "./TripTelematicDashboard.vue?vue&type=template&id=286460d0&scoped=true"
import script from "./TripTelematicDashboard.vue?vue&type=script&lang=js"
export * from "./TripTelematicDashboard.vue?vue&type=script&lang=js"
import style0 from "./TripTelematicDashboard.vue?vue&type=style&index=0&id=286460d0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286460d0",
  null
  
)

export default component.exports